import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { ResGetAllCategoryListQuery } from '@/lib/queries/business/v1/case/path/types'
import type { ResCategory } from '@/lib/queries/business/v1/types'

export const getCategoryListByApplicantQuery = ({
  applicantId,
  containsData,
}: {
  applicantId?: string
  containsData?: boolean
}) =>
  queryOptions({
    queryKey: [API_ENDPOINTS.business.v1.case.path.index, { applicantId, containsData }],
    queryFn: applicantId
      ? (): Promise<ResCategory[]> =>
          w.query({ containsData }).get(`${API_ENDPOINTS.business.v1.case.path.index}/${applicantId}`).json()
      : undefined,
  })

export const getAllCategoryListQuery = queryOptions({
  queryKey: [API_ENDPOINTS.business.v1.case.path.category.index],
  queryFn: (): Promise<ResGetAllCategoryListQuery> => w.get(API_ENDPOINTS.business.v1.case.path.category.index).json(),
  select: (data) =>
    data
      .filter(({ containCase }) => !containCase)
      .map((categoryItem) => ({
        ...categoryItem,
        _id: `${categoryItem.path_name}-${categoryItem.ids.join(',')}`,
      }))
      .sort((a, b) => a.path_name.localeCompare(b.path_name)),
})
